import {
  ADD_UNINSTALL,
  CANCEL_UNINSTALL,
  SET_SIZE_SORT,
  SET_TIME_SORT,
  GET_UNINSTALL_CATEGORY,
  GET_MIX_BATCH_DETAILS,
  SET_RRSIDUAL_LIST,
  SET_TEMP_RRSIDUAL_LIST,
  MODIFY_RESIDUAL_DATA,
  ADD_TEMP_RESIDUAL,
  REMOVE_TEMP_RESIDUAL,
  REMOVE_TRESIDUAL,
  STOP_SCAN_RESIDUAL,
  STOP_DELETE_RESIDUAL,
  GET_RESIDUAL_MIX_BATCH_DETAILS,
  GET_APP_LIST,
  SET_LOCAL_APP,
  REMOVE_CONSTRAIN,
} from '../constants/unintall';

export const setTimeSort = () => ({
  type: SET_TIME_SORT,
});

export const setSizeSort = () => ({
  type: SET_SIZE_SORT,
});

export const addUninstall = soft => ({
  type: ADD_UNINSTALL,
  soft,
});

export const cancelUninstall = soft => ({
  type: CANCEL_UNINSTALL,
  soft,
});

export const getUninstallCategory = payload => ({
  type: GET_UNINSTALL_CATEGORY,
  payload,
});

export const getMixBatchDetails = payload => ({
  type: GET_MIX_BATCH_DETAILS,
  payload,
});
export const getResidualMixBatchDetails = payload => ({
  type: GET_RESIDUAL_MIX_BATCH_DETAILS,
  payload,
});

// 存储残留列表文件

export const setResidualList = payload => ({
  type: SET_RRSIDUAL_LIST,
  payload,
});

// 存储临时残留列表文件

export const setTempResidualList = payload => ({
  type: SET_TEMP_RRSIDUAL_LIST,
  payload,
});

export const modifyResidualData = payload => ({
  type: MODIFY_RESIDUAL_DATA,
  payload,
});

export const addTempResidual = payload => ({
  type: ADD_TEMP_RESIDUAL,
  payload,
});

export const removeTempResidual = payload => ({
  type: REMOVE_TEMP_RESIDUAL,
  payload,
});

export const removeResidual = payload => ({
  type: REMOVE_TRESIDUAL,
  payload,
});

export const stopScanSoftwareResidual = payload => ({
  type: STOP_SCAN_RESIDUAL,
  payload,
});
export const stopDeleteResidual = payload => ({
  type: STOP_DELETE_RESIDUAL,
  payload,
});

// 获取备份应用列表
export const getUserAppList = payload => ({
  type: GET_APP_LIST,
  payload,
});

// 将本地的全部应用存放到reduce中
export const setLocalApp = payload => ({
  type: SET_LOCAL_APP,
  payload,
});

// 处理强制卸载失败的情况
export const removeConstrain = payload => ({
  type: REMOVE_CONSTRAIN,
  payload,
});
